import styled from "styled-components";

export const CommonHeadingWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "alignText",
})<{ alignText?: string }>`
  text-align: ${(props) => props.alignText || "center"};
  h2 {
    margin-bottom: 5px;
    &.heading_primary_color {
      color: rgb(255, 24, 24);
    }
  }
  p {
    font-size: 20px;
    @media (max-width: 899px) {
      font-size: 16px;
    }
    @media (max-width: 599px) {
      font-size: 14px;
    }
  }
  &.services_offer_heading {
    max-width: 1030px;
    margin: 0 auto;
  }
`;
